import { useFormContext } from 'react-hook-form';

import {
  CalculationMethodFormValues,
  isLadderCalculationMethodVisible,
} from '../utils/calculationMethodVisibility';

export const useLadderCalculationMethodVisibility = (): boolean => {
  const { watch } = useFormContext<CalculationMethodFormValues>();

  return isLadderCalculationMethodVisible(watch('ladder.steps'));
};
